window.addEventListener('DOMContentLoaded', function() {
  /* color-swatch__item */
  $('.product-item-meta__swatch-list .color-swatch.more').on('click', function(){
      $(this).hide();
      $(this).parents('.product-item-meta__swatch-list').find('.color-swatch').removeClass('hidden');
  });

  /* Fix quantity selector buttons */
  function fixQuantitySelector(selector) {
    if (selector.dataset.quantityFixed === 'true') return;
    selector.dataset.quantityFixed = 'true';

    const inputElement = selector.querySelector('input[is="input-number"]');
    const buttons = selector.querySelectorAll('button');

    if (inputElement && buttons.length === 2) {
      const [decreaseBtn, increaseBtn] = buttons;

      decreaseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const currentQty = parseInt(inputElement.value) || 1;
        inputElement.value = Math.max(1, currentQty - 1);
        inputElement.dispatchEvent(new Event('change', { bubbles: true }));
      }, true);

      increaseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const currentQty = parseInt(inputElement.value) || 1;
        inputElement.value = currentQty + 1;
        inputElement.dispatchEvent(new Event('change', { bubbles: true }));
      }, true);
    }
  }

  if (typeof customElements !== 'undefined') {
    customElements.whenDefined('quantity-selector').then(() => {
      document.querySelectorAll('quantity-selector').forEach(fixQuantitySelector);

      const quantityObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.tagName === 'QUANTITY-SELECTOR') {
                fixQuantitySelector(node);
              }
              const selectors = node.querySelectorAll && node.querySelectorAll('quantity-selector');
              if (selectors) {
                selectors.forEach(fixQuantitySelector);
              }
            }
          });
        });
      });

      quantityObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }).catch(function(err) {
      console.error('[Quantity Fix] Error:', err);
    });
  }
});
